import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type VerifyProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Verify = ({ size = 24, width, height, alt = '', style, ...props }: VerifyProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(0.58910162 0 0 0.58910162 2.00000000 2.23858616)',
        },
        [
          h(
            'mask',
            {
              id: 'mask0_18354_16029',
              maskUnits: 'userSpaceOnUse',
              x: '0',
              y: '0',
              width: '29',
              height: '33',
            },
            [
              h(
                'path',
                {
                  d: 'M28.2214 7.3747C28.1212 6.38873 27.3965 5.58096 26.4293 5.37713C24.4684 5.06802 22.5316 4.62096 20.6333 4.03927C18.7743 3.27482 17.0312 2.2532 15.4547 1.00414C14.628 0.407474 13.5135 0.407474 12.6868 1.00414C11.1945 2.38813 9.41139 3.4186 7.46899 4.01957C5.67043 4.76526 3.77048 5.23615 1.83257 5.41652C0.844106 5.57667 0.103792 6.41103 0.0601447 7.41409C0.0601447 7.41409 0 12.4271 0 16.8395C0 24.8273 9.39976 32.5566 14.1009 32.5566C18.8007 32.5566 26.7681 27.1042 28.0422 16.9601C28.3613 10.9686 28.1404 7.3944 28.1404 7.3944L28.2214 7.37347V7.3747Z',
                  fill: 'white',
                },
              ),
            ],
          ),
          h(
            'g',
            {
              mask: 'url(#mask0_18354_16029)',
            },
            [
              h(
                'path',
                {
                  d: 'M28.2214 7.3747C28.1212 6.38873 27.3965 5.58096 26.4293 5.37713C24.4684 5.06802 22.5316 4.62096 20.6333 4.03927C18.7743 3.27482 17.0312 2.2532 15.4547 1.00414C14.628 0.407474 13.5135 0.407474 12.6868 1.00414C11.1945 2.38813 9.41139 3.4186 7.46899 4.01957C5.67043 4.76526 3.77048 5.23615 1.83257 5.41652C0.844106 5.57667 0.103792 6.41103 0.0601447 7.41409C0.0601447 7.41409 0 12.4271 0 16.8395C0 24.8273 9.39976 32.5566 14.1009 32.5566C18.8007 32.5566 26.7681 27.1042 28.0422 16.9601C28.3613 10.9686 28.1404 7.3944 28.1404 7.3944L28.2214 7.37347V7.3747Z',
                  fill: '#FFCF4C',
                },
              ),
              h(
                'path',
                {
                  d: 'M33.9492 -5.36914H14.2115V51.9148H33.9492V-5.36914Z',
                  fill: '#FFB000',
                },
              ),
            ],
          ),
          h(
            'path',
            {
              d: 'M18.5936 20.3353C17.932 20.9673 16.9213 21.0668 16.1495 20.5748L15.7635 20.245L9.61595 13.7545C8.85831 12.9291 8.91138 11.6442 9.73448 10.8845C10.5576 10.1248 11.839 10.178 12.5967 11.0033L17.3127 16.0602L30.5513 3.50232C31.0841 3.01088 31.8379 2.84178 32.5287 3.05872C33.2195 3.27566 33.7425 3.84568 33.9005 4.55406C34.0586 5.26244 33.8278 6.00156 33.295 6.493V6.43219L18.5936 20.3353Z',
              fill: '#00AB47',
            },
          ),
        ],
      ),
    ],
  );

export default Verify;
